import API from "../Common/Endpoint/serviceConstrants";
import axiosInstanceClient from '../Common/Axios/axiosInstanceClient'
export const cmsApi = async () => {
  const { data = {} } = await axiosInstanceClient.get(API.getcms);
  return data;
};
